import React, { Component } from "react";
import { Card, CardHeader, CardBody, Col } from "reactstrap";
import FlagItem from "./FlagItem";
import { CLOUDINARY_SHARE } from "../../helpers/cloudinaryConstants";

class UserItem extends Component {
  shouldComponentUpdate(nextProps) {
    return this.props.gnObject.id !== nextProps.gnObject.id;
  }

  render() {
    const { gnObject } = this.props;
    return (
      <Col xs="12" md="6">
        <Card>
          <CardHeader>User</CardHeader>
          <CardBody>
            <h5>User: {gnObject.user.username}</h5>
            <h6>User ID: {gnObject.user.id}</h6>
            <hr />
            <img
              style={{ width: "50%" }}
              src={`${CLOUDINARY_SHARE}/${
                gnObject.user.avatar.image.cloudinaryId
              }`}
            />
            <br />
            <a
              href={`${APP_BASE_URL}/users/${gnObject.user.username}`}
              target="__blank"
              rel="noopener noreferrer"
            >
              Visit Profile
            </a>
          </CardBody>
          {this.props.children}
        </Card>
      </Col>
    );
  }
}

export default UserItem;



// WEBPACK FOOTER //
// ./src/views/Components/UserItem.js